export default __webpack_public_path__ + "4ef81144be72f197aabdbb19d6255a64.svg";